import styled from '@emotion/styled';
import { fonts } from '@theme/fontsCustomer';
import type { WorkflowBaseTriggerDTOModel } from '@repositories/workflowBaseTriggerRepository/models/WorkflowBaseTriggerDTOModel';
import { TriggerIcon as TriggerIconComponent } from './TriggerIcon';

interface InnerTriggerProps {
  trigger: WorkflowBaseTriggerDTOModel;
}

export const InnerTrigger = ({ trigger }: InnerTriggerProps) => {
  return (
    <InnerTriggerContainer>
      <TriggerIcon>
        <TriggerIconComponent triggerName={trigger.eventName} />
      </TriggerIcon>
      <TriggerInfo>
        <TriggerName>{trigger.name}</TriggerName>
        <TriggerDescription>{trigger.description}</TriggerDescription>
      </TriggerInfo>
    </InnerTriggerContainer>
  );
};

// interface Props {
//   trigger: WorkflowBaseTriggerDTOModel;
//   onClick: (trigger: WorkflowBaseTriggerDTOModel) => void;
//   selected?: string;
// }

// export const Trigger = ({ trigger, onClick: handleClick, selected }: Props) => {
//   return (
//     <TriggerElements onClick={() => handleClick(trigger)} isSelected={selected === trigger.id}>
//       <InnerTrigger trigger={trigger} />
//     </TriggerElements>
//   );
// };

// const TriggerElements = styled.div<{ isSelected?: boolean }>`
//   display: flex;
//   width: 100%;
//   padding: 18px 30px;
//   background-color: ${props =>
//     props.isSelected ? props.theme.colors['bg-primary-lighter'] : props.theme.colors['bg-white']};
//   border: 1px solid
//     ${props =>
//       props.isSelected ? props.theme.colors['border-primary-light'] : props.theme.colors['border-gray-lighter']};
//   border-radius: 5px;

//   :hover {
//     border: 1px solid ${({ theme: { colors } }) => colors['border-primary-light']};
//     background-color: ${({ theme: { colors } }) => colors['state-white-primary-hover']};
//     box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.02);
//   }
// `;

const InnerTriggerContainer = styled.div<{ isSelected?: boolean }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  gap: 16px;
`;

const TriggerIcon = styled.span`
  display: flex;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
`;

const TriggerInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const TriggerName = styled.strong`
  ${fonts.Headline8};
  color: ${({ theme: { colors } }) => colors['text-gray-main']};
  transition: color 0.2s;
`;

const TriggerDescription = styled.p`
  ${fonts.Body2};
  color: ${({ theme: { colors } }) => colors['text-gray-sub-dark']};
  transition: color 0.2s;
  margin: 0;
`;
